module.exports = "/_next/static/images/76b32c7ad161909f213015a2f34ba043-man-with-cellphone-xs@2x.jpg.webp";